/* Native cart actions and inventory remain owned by the theme. */
(() => {
  const threshold = 300000; // PKR minor units; verified general shipping profile.
  function renderDelivery(box, total) {
    if (box.dataset.currency !== 'PKR' || !Number.isFinite(total)) return;
    box.querySelector('progress').value = Math.min(threshold, Math.max(0, total));
    const remaining = Math.max(0, threshold - total);
    box.querySelector('[data-rf-delivery-message]').textContent = remaining
      ? `Add Rs ${(remaining / 100).toLocaleString('en-PK', {maximumFractionDigits: 2})} more for free delivery in Pakistan.`
      : 'Your order qualifies for free delivery in Pakistan.';
  }
  function initDelivery() {
    document.querySelectorAll('[data-rf-delivery]').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const form = box.closest('form');
      const products = form?.querySelector('[data-products]');
      const update = () => {
        const subtotal = products?.querySelector('[data-cart-subtotal]');
        renderDelivery(box, Number(subtotal ? subtotal.dataset.cartSubtotal : box.dataset.total));
      };
      if (products) new MutationObserver(update).observe(products, {childList:true,subtree:true});
      document.addEventListener('cart:updated', event => {
        if (event.detail?.cart) renderDelivery(box, event.detail.cart.total_price);
      });
      update();
    });
  }
  function initSticky() {
    document.querySelectorAll('[data-rf-mobile-cart]').forEach(bar => {
      if (bar.dataset.ready) return;
      const section = bar.closest('.product-section');
      const original = section?.querySelector('form.product-single__form [data-add-to-cart]');
      if (!original) return;
      bar.dataset.ready = 'true';
      const button = bar.querySelector('[data-rf-mobile-add]');
      const price = section.querySelector('[data-product-price]');
      const mobile = matchMedia('(max-width:700px)');
      function sync() {
        const rect = original.getBoundingClientRect();
        // Appear only after shoppers have scrolled past the original purchase controls.
        const visible = mobile.matches && rect.bottom < 0 && !document.documentElement.classList.contains('js-drawer-open');
        bar.hidden = !visible;
        document.body.classList.toggle('rf-mobile-cart-visible', visible);
        button.disabled = original.disabled || original.classList.contains('btn--loading');
        button.textContent = original.querySelector('[data-add-to-cart-text]')?.textContent.trim() || 'Add to cart';
        if (price) bar.querySelector('[data-rf-mobile-price]').textContent = price.textContent;
      }
      button.addEventListener('click', () => { if (!button.disabled) original.click(); });
      new MutationObserver(sync).observe(original,{attributes:true,childList:true,subtree:true});
      if (price) new MutationObserver(sync).observe(price,{childList:true,subtree:true});
      new MutationObserver(sync).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
      let scheduled = false;
      window.addEventListener('scroll', () => {if (!scheduled) {scheduled=true;requestAnimationFrame(()=>{scheduled=false;sync();});}}, {passive:true});
      window.addEventListener('resize',sync);
      sync();
    });
  }
  function init(){initDelivery();initSticky();}
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
